import React, { useState } from 'react';
import './styles/ReusableSearchBar.css';

const ReusableSearchBar = ({ onSearch, onClear, placeholder, searchButtonText, clearButtonText }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = () => {
    if (searchTerm.trim()) {
      onSearch(searchTerm.trim());
    }
  };

  const handleClear = () => {
    setSearchTerm('');
    if (onClear) {
      onClear();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  }

  return (
    <div className="search-bar-container">
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder={placeholder || 'Buscar...'}
      />
      <button onClick={handleSearch}>{searchButtonText || 'Buscar'}</button>
      {onClear && <button onClick={handleClear}>{clearButtonText || 'Limpiar'}</button>}
    </div>
  );
};

export default ReusableSearchBar; 